<template>
  <section class="testimonials-section py-20">
    <v-container>
      <div class="text-center" data-aos="fade-up">
        <div class="section-subtitle">
          <span class="subtitle-line"></span>
          <span class="section-title">What Our Clients Say</span>
          <span class="subtitle-line"></span>
        </div>
        <p class="section-description">Real feedback from real customers</p>
      </div>

      <div
        class="testimonials-slider"
        ref="slider"
        @mousedown="startDrag"
        @mousemove="onDrag"
        @mouseup="endDrag"
        @mouseleave="endDrag"
        @touchstart="startDrag"
        @touchmove="onDrag"
        @touchend="endDrag"
      >
        <div
          class="testimonials-track"
          :style="{ transform: `translateX(${translateX}px)` }"
        >
          <div
            v-for="(testimonial, index) in doubledTestimonials"
            :key="index"
            class="testimonial-card-wrapper"
          >
            <div class="testimonial-card">
              <div class="card-header">
                <div class="avatar-container">
                  <v-avatar size="48" color="#f46523" class="avatar-circle">
                    <span class="avatar-text white--text">{{
                      testimonial.initial
                    }}</span>
                  </v-avatar>
                </div>
                <div class="client-details">
                  <div class="client-name">{{ testimonial.name }}</div>
                  <div class="client-location">
                    <span class="location-icon">📍</span>
                    {{ testimonial.location }}
                  </div>
                </div>
              </div>

              <div class="rating-wrapper mt-3">
                <v-rating
                  :value="testimonial.rating"
                  color="#FFC107"
                  background-color="#E0E0E0"
                  readonly
                  dense
                  size="18"
                  class="rating-stars"
                ></v-rating>
              </div>

              <p class="testimonial-text mt-4">{{ testimonial.text }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="slider-dots mt-8">
        <span
          v-for="(testimonial, index) in currentTestimonials"
          :key="index"
          class="dot"
          :class="{ active: currentDot === index }"
        ></span>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "TestimonialsPlayStore",
  data() {
    return {
      isDragging: false,
      startX: 0,
      currentX: 0,
      velocity: 0,
      lastX: 0,
      translateX: 0,
      sliderWidth: 0,
      animationFrame: null,
      animateBound: null,
      currentDot: 0,
      testimonialsIndia: [
        {
          name: "Athira S",
          location: "Kochi",
          initial: "AS",
          rating: 5,
          text: "We had a sudden leak in the kitchen, and they came within an hour! Problem was fixed quickly, and the charges were reasonable. Highly recommend for emergency plumbing needs.",
        },
        {
          name: "Deepak Vasudev",
          location: "Bangalore",
          initial: "DV",
          rating: 4.5,
          text: "Always on time, friendly, and passionate about their work. My garden has never looked better, and I get compliments from all my neighbors!",
        },
        {
          name: "Aswani Vishnu",
          location: "Thrissur",
          initial: "AV",
          rating: 4.5,
          text: "I was worried about frequent power trips at home, but their electrician identified the problem in minutes and fixed it neatly. They explained everything clearly, which I really appreciated.",
        },
      ],
      testimonialsUSA: [
        {
          name: "William",
          location: "Chicago",
          initial: "WL",
          rating: 4.5,
          text: "We had a sudden leak in the kitchen, and they came within an hour! Problem was fixed quickly, and the charges were reasonable. Highly recommend for emergency plumbing needs.",
        },
        {
          name: "Ezra",
          location: "New York",
          initial: "EZ",
          rating: 5,
          text: "Always on time, friendly, and passionate about their work. My garden has never looked better, and I get compliments from all my neighbors!",
        },
        {
          name: "Noah",
          location: "San Francisco",
          initial: "NH",
          rating: 4.5,
          text: "I was worried about frequent power trips at home, but their electrician identified the problem in minutes and fixed it neatly. They explained everything clearly, which I really appreciated.",
        },
      ],
    };
  },
  computed: {
    currentLocation() {
      return (
        (this.$route && this.$route.meta && this.$route.meta.location) ||
        "india"
      );
    },
    currentTestimonials() {
      if (this.currentLocation === "us") return this.testimonialsUSA;
      return this.testimonialsIndia;
    },
    doubledTestimonials() {
      return [...this.currentTestimonials, ...this.currentTestimonials];
    },
  },
  watch: {
    currentLocation() {
      this.translateX = 0;
      this.currentDot = 0;
      this.$nextTick(() => {
        this.sliderWidth = this.$refs.slider
          ? this.$refs.slider.scrollWidth / 2
          : 0;
        this.updateCurrentDot();
      });
    },
    currentTestimonials() {
      this.$nextTick(() => {
        this.sliderWidth = this.$refs.slider
          ? this.$refs.slider.scrollWidth / 2
          : 0;
        this.updateCurrentDot();
      });
    },
  },
  mounted() {
    this._animateBound = this.animate.bind(this);
    this.sliderWidth = this.$refs.slider
      ? this.$refs.slider.scrollWidth / 2
      : 0;
    this.animationFrame = requestAnimationFrame(this._animateBound);
    this.updateCurrentDot();
  },
  beforeDestroy() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
  },
  methods: {
    _getPageX(e) {
      if (!e) return 0;
      if (e.type && e.type.startsWith("touch")) {
        if (e.touches && e.touches[0]) return e.touches[0].pageX;
        if (e.changedTouches && e.changedTouches[0])
          return e.changedTouches[0].pageX;
        return 0;
      }
      return e.pageX !== undefined ? e.pageX : e.clientX || 0;
    },

    startDrag(e) {
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
      }
      this.isDragging = true;
      const pageX = this._getPageX(e);
      this.startX = pageX;
      this.lastX = pageX;
      this.velocity = 0;
    },

    onDrag(e) {
      if (!this.isDragging) return;
      const pageX = this._getPageX(e);
      const delta = pageX - this.lastX;
      this.translateX += delta;
      this.lastX = pageX;
      this.velocity = delta;
      this.updateCurrentDot();
    },

    endDrag() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.momentumScroll();
    },

    momentumScroll() {
      const friction = 0.95;
      const step = () => {
        this.translateX += this.velocity;
        this.velocity *= friction;

        if (this.sliderWidth && this.translateX < -this.sliderWidth) {
          this.translateX = 0;
        }
        if (this.sliderWidth && this.translateX > 0) {
          this.translateX = -this.sliderWidth;
        }

        this.updateCurrentDot();

        if (Math.abs(this.velocity) > 0.3) {
          this.animationFrame = requestAnimationFrame(step);
        } else {
          this.animationFrame = requestAnimationFrame(this._animateBound);
        }
      };
      this.animationFrame = requestAnimationFrame(step);
    },

    animate() {
      if (!this.isDragging) {
        this.translateX -= 0.3;
        if (this.sliderWidth && this.translateX < -this.sliderWidth) {
          this.translateX = 0;
        }
        this.updateCurrentDot();
      }
      this.animationFrame = requestAnimationFrame(this._animateBound);
    },

    updateCurrentDot() {
      let cardWidth = 380;
      try {
        const slider = this.$refs.slider;
        if (slider && slider.querySelector) {
          const wrapper = slider.querySelector(".testimonial-card-wrapper");
          if (wrapper && wrapper.offsetWidth) {
            cardWidth = wrapper.offsetWidth;
          }
        }
      } catch (err) {
        // ignore
      }

      const len =
        (this.currentTestimonials && this.currentTestimonials.length) || 1;
      const absTranslate = Math.abs(this.translateX || 0);
      const rawIndex = Math.floor(absTranslate / cardWidth);
      const idx = rawIndex % len;
      this.currentDot = idx;
    },
  },
};
</script>

<style scoped>
.testimonials-section {
  background: #ffffff;
  position: relative;
  overflow: hidden;
  padding-bottom: 40px;
  user-select: none;
}

.section-title {
  font-size: clamp(2rem, 4vw, 2.8rem);
  font-weight: 900;
  padding-bottom: 10px;
  color: #f46523;
  position: relative;
  z-index: 1;
}

.section-subtitle {
  color: #1a1a1a;
  font-weight: 800;
  letter-spacing: 5px;
  font-size: 13px;
  text-transform: uppercase;
  margin-top: 50px;
  display: inline-flex;
  align-items: center;
  gap: 15px;
  position: relative;
  z-index: 1;
}

.testimonials-slider {
  overflow: hidden;
  position: relative;
  padding: 2rem 0;
  cursor: grab;
}

.testimonials-slider:active {
  cursor: grabbing;
}

.testimonials-track {
  display: flex;
  gap: 20px;
  transition: transform 0.2s ease-out;
}

.testimonial-card-wrapper {
  flex: 0 0 auto;
  width: 360px;
}

.testimonial-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  border: 1px solid #e8eaed;
  transition: all 0.3s ease;
  height: 240px;
  display: flex;
  flex-direction: column;
}

.testimonial-card:hover {
  box-shadow:
    0 4px 8px rgba(0, 0, 0, 0.16),
    0 2px 4px rgba(0, 0, 0, 0.23);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar-container {
  flex-shrink: 0;
}

.avatar-circle {
  font-weight: 600;
}

.avatar-text {
  font-size: 18px;
  font-weight: 600;
}

.client-details {
  flex: 1;
  min-width: 0;
}

.client-name {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.3;
  margin-bottom: 2px;
}

.client-location {
  font-size: 14px;
  color: #5f6368;
  display: flex;
  align-items: center;
  gap: 4px;
}

.location-icon {
  font-size: 12px;
}

.rating-wrapper {
  display: flex;
  align-items: center;
}

.rating-stars {
  margin: 0;
  padding: 0;
}

.rating-stars >>> .v-icon {
  padding: 0 2px;
}

.testimonial-text {
  font-size: 14px;
  line-height: 1.6;
  color: #3c4043;
  margin: 0;
  flex-grow: 1;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

.slider-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #dadce0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.dot.active {
  background: #f46523;
  width: 24px;
  border-radius: 4px;
}

@media (max-width: 960px) {
  .testimonial-card-wrapper {
    width: 320px;
  }

  .section-title {
    font-size: 24px;
  }

  .section-subtitle {
    font-size: 14px;
  }
}

@media (max-width: 600px) {
  .testimonial-card-wrapper {
    width: 280px;
  }

  .testimonial-card {
    padding: 16px;
    height: 220px;
  }

  .section-title {
    font-size: 22px;
  }

  .client-name {
    font-size: 15px;
  }

  .client-location {
    font-size: 13px;
  }

  .testimonial-text {
    font-size: 13px;
  }

  .avatar-circle {
    width: 40px !important;
    height: 40px !important;
  }

  .avatar-text {
    font-size: 16px;
  }
}

.testimonials-track {
  will-change: transform;
}

.testimonial-card {
  will-change: transform, box-shadow;
}
.card-accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #f46523, #ff8a5c, #f46523);
  background-size: 200% 100%;
  animation: gradientShift 3s ease infinite;
}

.subtitle-line {
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #f46523, transparent);
  display: inline-block;
  animation: lineGrow 2s infinite ease-in-out;
}
</style>
